import React, { useEffect } from 'react'
import Footer from './Footer'
import WorkTogether from './WorkTogether'
import AboutUs from './AboutUs'
import Quotes from './Quotes'
import Banner from './Banner.js'
import { openVolunteerPopup } from '../features/volunteerPopupSlice.js'
import { useDispatch } from 'react-redux'
import VolunteerFormPopup from '../volunteerForm/VolunteerFormPopup.js'

export default function HomePage() {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const shown = sessionStorage.getItem("volunteerPopupShown");
  //   console.log("shown", shown)
  //   if (!shown) {

  //     const timer = setTimeout(() => {
  //       dispatch(openVolunteerPopup());
  //       sessionStorage.setItem("volunteerPopupShown", "true");
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [dispatch]);
  return (
    <div>
       <VolunteerFormPopup />
      <Banner />
      <AboutUs />
      <WorkTogether />
      <Quotes />
      {/* <DonationSection/> */}
      <Footer />
    </div>
  )
}
